export const DESKTOP = 1200;
export const MOBILE = 768;
export const MOBILE_SMALL = 565;
